import React from 'react'
import { RADOM_COLORS } from './Constants'

export const EU_TRAVEL_RULES_COMPLIANCE_TEXT: React.ReactElement =
  <div style={{
    flex: 1,
    fontSize: 10,
    color: RADOM_COLORS.GRAY_DARKER,
    overflowWrap: 'break-word'
  }}>
    <span>We are required to collect your billing details to comply with
      <a style={{ color: RADOM_COLORS.BLUE5 }} target='_new' href='https://eur-lex.europa.eu/eli/reg/2023/1113/oj/eng'> regulatory requirements</a>.
      Any personal data is securely stored and only used for compliance purposes
    </span>
  </div>

export const RADOM_PRIVACY_CONFIRMATION =
  <div style={{
    flex: 1,
    fontSize: 10,
    color: RADOM_COLORS.GRAY_DARKER,
    overflowWrap: 'break-word',
    marginLeft: 15
  }}>
    <span>I confirm that the information provided is accurate and complete. I have read the
      <a style={{ color: RADOM_COLORS.BLUE5 }} target='_new' href='https://www.radom.com/privacy'> Privacy Notice</a>.
    </span>
  </div>
